import { Typography } from "@/components/atoms";
import { PreferredDriver } from "@/redux/apis/clientDispatch/types";
import { RemovePreferredDriverAction } from "./components/RemovePreferredDriverAction";
import { PreferredDriversSortKey, PreferredDriversTableData } from "./types";

/** Client-side sort — we fetch all preferred drivers at once (mobile parity), so the server doesn't sort. */
export const sortPreferredDrivers = (
  drivers: PreferredDriver[],
  key: PreferredDriversSortKey | undefined,
  desc: boolean
): PreferredDriver[] => {
  if (!key) return drivers;
  return [...drivers].sort((a, b) => {
    // numeric: true keeps share codes like D9/D10 in natural order.
    const cmp = (a[key] ?? "").toString().localeCompare((b[key] ?? "").toString(), undefined, { sensitivity: "base", numeric: true });
    return desc ? -cmp : cmp;
  });
};

export const generatePreferredDriversData = (drivers: PreferredDriver[], accountId?: string): PreferredDriversTableData[] =>
  drivers.map((driver) => ({
    driverId: <Typography>{driver.driverId}</Typography>,
    driverName: <Typography>{driver.driverName}</Typography>,
    action: <RemovePreferredDriverAction driver={driver} accountId={accountId} />,
  }));
